<template>
  <div>
    <div v-if="matter">
      WELCOME TO MASS TORT MATTER PAGE: {{ matter.matterID }}
    </div>
    <div v-if="this.hasContentsList">
      <v-btn @click="goToContentsList">SEE CONTENTS LIST</v-btn>
    </div>
    <!-- <v-btn small rounded @click="saveConents">save contents</v-btn> -->
  </div>
</template>

<script>
import * as firebase from "firebase";
export default {
  data: () => ({
    matter: null,
    hasContentsList: null
  }),
  methods: {
    goToContentsList() {
      console.log("router", this.$router.params);
      // this.$router.push("/contents");
      this.$router.push({
        name: "ContentsStepper3",
        params: { location: this.matter.matterID }
      });
    }
    // saveConents() {
    //   this.matter.contentsList.forEach(contentsListItem => {
    //     if (contentsListItem.pricing !== null) {
    //       firebase
    //         .firestore()
    //         .collection("fireMatters")
    //         .doc(this.matter.matterID)
    //         .collection("contentsList")
    //         .doc(contentsListItem.pricing.searchTerms)
    //         .set(contentsListItem);
    //     }
    //   });
    // }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    firm() {
      return this.$store.getters.firm;
    },
    role() {
      return this.$store.getters.role;
    }
  },
  watch: {
    user(val) {
      if (val !== null && val !== undefined) {
        if (this.role === "admin" && this.$route.params.type === "fire") {
          firebase
            .firestore()
            .collection("fireMatters")
            .doc(this.$route.params.id)
            .onSnapshot(doc => {
              this.matter = doc.data();
              console.log("this.matter in MassTortMatter page", this.matter);
            });
        }
      }
    },
    matter(val) {
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(val.matterID)
        .collection("contentsList")
        .limit(1)
        .get()
        .then(resp => {
          console.log("doc from matter at watch", resp);
          if (resp.docs.length > 0) {
            this.hasContentsList = true;
          } else {
            console.log("no contents");
          }
        });
    }
  },
  created() {
    console.log("Mass Tort Matter router", this.$route.params);
    if (this.role === "admin" && this.$route.params.type === "fire") {
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.$route.params.id)
        .get()
        .then(doc => {
          this.matter = doc.data();
          console.log("this.matter in MassTortMatter page", this.matter);
        })
        .catch(e => console.error(e.message));
    }
  }
};
</script>

<style></style>
